import React from "react";
import { AiFillGithub, AiFillInstagram, AiFillLinkedin } from "react-icons/ai";
import { FaTelegramPlane } from "react-icons/fa";
import { MdCall, MdEmail } from "react-icons/md";
import "./footer.scss";

const Footer = () => {
  return (
    <div id="contact">
      <div className="footer-wrapper">
        <div className="link-list">
          <div className="link-column">
            <MdCall size="4rem" />
            <a className="link-item" href="tel:+25192310324">
              092-313-0324
            </a>
          </div>
          <div className="link-column">
            <MdEmail size="4rem" />
            <a className="link-item" href="mailto:danieltda99@gmail.com">
              danieltda99@gmail.com
            </a>
          </div>
        </div>
        <div className="social-icons-container">
          <div className="company-container">
            <div className="slogan">Innovating one project at a time</div>
          </div>
          <div className="social-container">
            <a className="social-icons" href="https://t.me/dah_knee">
              <FaTelegramPlane size="3rem" />
            </a>
            <a className="social-icons" href="https://github.com/dannytolla">
              <AiFillGithub size="3rem" />
            </a>
            <a
              className="social-icons"
              href="https://www.linkedin.com/in/daniel-tola-1986911a3"
            >
              <AiFillLinkedin size="3rem" />
            </a>
            <a
              className="social-icons"
              href="https://www.instagram.com/dannyda99/"
            >
              <AiFillInstagram size="3rem" />
            </a>
          </div>
        </div>
        <div className="footer-copy-right">
          {" "}
          <span className="footer-first">
            {" "}
            &copy; <span>{`${new Date().getFullYear()}`}</span>{" "}
          </span>
          <p>Daniel Tolla</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
